import React, { useEffect, useState } from 'react';
import api from '@/lib/api';

export default function AdBanner({ placement = 'homepage' }) {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    api.get(`/banners?placement=${placement}`).then(r => setBanners(r.data)).catch(() => {});
  }, [placement]);

  if (banners.length === 0) {
    return (
      <div className="bg-[#F4F1EA] border border-[#E8E6DF] rounded-2xl p-6 text-center" data-testid={`ad-banner-${placement}`}>
        <div className="flex items-center justify-center gap-3">
          <img
            src="https://images.unsplash.com/photo-1693259074195-4235f7946471?w=120&h=80&fit=crop"
            alt="Ad placeholder"
            className="w-20 h-14 rounded-lg object-cover opacity-60"
          />
          <div className="text-left">
            <p className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">Sponsored</p>
            <p className="text-sm text-[#2C362F] font-medium">Your Local Business Here</p>
            <p className="text-xs text-muted-foreground">Reach your community. Advertise with us.</p>
          </div>
        </div>
      </div>
    );
  }

  const banner = banners[0];
  return (
    <a
      href={banner.link_url || '#'}
      target="_blank"
      rel="noopener noreferrer"
      className="block bg-[#F4F1EA] border border-[#E8E6DF] rounded-2xl overflow-hidden hover:shadow-md transition-shadow"
      data-testid={`ad-banner-${placement}`}
    >
      <div className="flex items-center gap-4 p-4">
        <img src={banner.image_url} alt={banner.title} className="w-24 h-16 rounded-lg object-cover" />
        <div>
          <p className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">Sponsored</p>
          <p className="text-sm font-medium text-[#2C362F]">{banner.title}</p>
        </div>
      </div>
    </a>
  );
}
